import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DataService } from "src/app/shared/services/data.service";
import { StorageService } from "src/app/shared/services/storage.service";

@Component({
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.scss"],
})
export class MyAccountComponent implements OnInit {
  public userName: string;
  public profileImg: "assets/images/dashboard/profile.jpg";

  constructor(
    public router: Router,
    private dataService: DataService,
    private storageService: StorageService
  ) {
    if (JSON.parse(localStorage.getItem("user"))) {
    } else {
    }
  }

  ngOnInit() {}

  logoutFunc() {
    this.dataService.showFullPageLoader();
    this.storageService.clear();
    setTimeout(() => {
      this.router.navigateByUrl('auth/login').then(() => {
        this.dataService.hideFullPageLoader();
      });
    }, 400);
  }
}
